import React from "react";

import {LessonNavigationProvider} from "./LessonNavigationContext";
import {LessonPlaybackProvider} from "./LessonPlaybackStateContext";
import {AudioPlaybackProvider} from "./AudioPlaybackContext";

const LessonStateContext = ({children, step, isUserInteractionRequired, audioUrl, sectionIndex, subSectionIndex, sectionsTotal, subSectionTotal} ) => {
    return (
        <LessonPlaybackProvider>
            <AudioPlaybackProvider audioSrc={audioUrl} sectionIndex={sectionIndex} subSectionIndex={subSectionIndex}>
                <LessonNavigationProvider
                    step={step}
                    isUserInteractionRequired={isUserInteractionRequired}
                    audioUrl={audioUrl}
                    sectionIndex={sectionIndex}
                    subSectionIndex={subSectionIndex}
                    sectionsTotal={sectionsTotal}
                    subSectionTotal={subSectionTotal}
                >
                    {children}
                </LessonNavigationProvider>
            </AudioPlaybackProvider>
        </LessonPlaybackProvider>
    )
}

export default LessonStateContext;